import Grid16 from '@carbon/icons-react/es/grid/16';
import List16 from '@carbon/icons-react/es/list/16';
import { Tabs as AntTabs } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { IconShell } from 'components/atoms/icon-shell';
import { AttachmentsTabViews } from './types';

const { TabPane } = AntTabs;

const Tabs = styled(AntTabs)`
  .ant-tabs-nav {
    margin-bottom: 0;

    &::before {
      border-bottom: none;
    }
  }

  .ant-tabs-ink-bar-animated {
    display: none;
  }

  .ant-tabs-tab {
    padding: 0;
    min-width: auto;
    border-bottom: none;
  }
`;

export const AttachmentsTabs: FC<{
  onChooseTab(tab: AttachmentsTabViews): void;
  downloadLink?: React.ReactNode;
}> = ({ onChooseTab, downloadLink }) => {
  const handleTabChange = (_activeTab) => {
    onChooseTab(_activeTab);
  };

  const handleTabClick = (
    key: string,
    e: React.MouseEvent<Element> | React.KeyboardEvent<Element>,
  ) => {
    e.stopPropagation();
  };

  return (
    <Tabs
      defaultActiveKey={AttachmentsTabViews.GridView}
      onTabClick={handleTabClick}
      onChange={handleTabChange}
    >
      <TabPane
        key={AttachmentsTabViews.GridView}
        tab={<IconShell size="small" icon={<Grid16 />} />}
      />
      <TabPane
        key={AttachmentsTabViews.TableView}
        tab={<IconShell size="small" icon={<List16 />} />}
      />
      {downloadLink ? <TabPane key="downloadLink" tab={downloadLink} /> : null}
    </Tabs>
  );
};
